module.exports = __webpack_public_path__ + "img/ta_askfor_result-qrimg2.bed11a0d.png";